import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Tooltip,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg59 from "./../../../../assets/svg/svg59.svg";
import svg60 from "./../../../../assets/svg/svg60.svg";
import deleteRed from "./../../../../assets/svg/delete-red.svg";
import {
  fetchData,
  fetchPaybills,
  fetchPaymentModes,
  fetchSubwalletDropdown,
} from "../../../../features/fetch/fetchSlice";
import { paymentMethodsData } from "../../../../data";
import { saveFileUploadBulk } from "../../../../features/save/saveSlice";
import { useWatch } from "antd/es/form/Form";
import CategoryAdd from "../../../setup/category/modal/CategoryAdd";
import SubCategoryAdd from "../../../setup/sub-category/modal/SubCategoryAdd";
import { downloadExcel } from "../../../../features/global/globalSlice";
import { formatPath } from "../../../../utils";

const { TextArea } = Input;

const BulkPaymentModal = ({ open, handleCancel }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { banks, paymentModes, dropLoading, mainWalletData, subwalletData } =
    useSelector((state) => state.fetch);

  const { saving } = useSelector((state) => state.save);
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const urlSubCat = "api/v1/payments/fetch-sub-categories";
  const urlPaybill = "api/v1/payments/fetch-paybills";

  const { loading, dataCat, dataSubCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
    dataSubCat: state.fetch.data[urlSubCat] || [],
  }));

  const { glbLoading } = useSelector((state) => state.global);

  const [paymentSourceName, setPaymentSourceName] = useState();
  const [paymentModeName, setPaymentModeName] = useState();

  const [openCategory, setopenCategory] = useState(false);
  function handleCancelCategory() {
    setopenCategory(false);
  }

  const [openSubCategory, setopenSubCategory] = useState(false);
  function handleCancelSubCategory() {
    setopenSubCategory(false);
  }

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setShow();
  }

  const [file, setFile] = useState();
  const [formData, setFormData] = useState();
  const [show, setShow] = useState();
  const [uploadedFile, setUploadedFile] = useState();

  const onFinish = async (data) => {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    } else {
      toast.error("File is null or undefined");
      return;
    }
    const res = await dispatch(
      saveFileUploadBulk({
        formData,
        url:
          show === "BANK"
            ? `payment-staging/upload-bank?pyWalId=${data?.pyWalId}&pyPcId=${
                data?.pyPcId ?? ""
              }&pyPscId=${data?.pyPscId ?? ""}`
            : show === "MOBILE_MONEY"
            ? `payment-staging/upload-mpesa?pyWalId=${data?.pyWalId}&pyPcId=${
                data?.pyPcId ?? ""
              }&pyPscId=${data?.pyPscId ?? ""}`
            : null,
      })
    );
    console.log("res payload,", res?.payload?.data?.result?.fileName);
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await setFile("");
      await setShow("");
      await setUploadedFile("");
      await navigate("/bulk-verification");
    } else {
      await setUploadedFile(res?.payload?.data?.result?.fileName);
      await toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }

  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }

  const pyPcId = useWatch("pyPcId", form);

  async function fetchCategoryData() {
    dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      })
    );
  }

  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }

  const handleDownload = async (item) => {
    const res = await dispatch(
      downloadExcel({
        url:
          item === "BANK"
            ? "payment-staging/bank-template"
            : "payment-staging/mpesa-template",
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];

      let fileName = "Upload_template";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };

  const handleDownloadUploaded = async (item) => {
    const res = await dispatch(
      downloadExcel({
        url: `payment-staging/view-uploaded-file?fileName=${item}`,
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];

      let fileName = "Upload_template";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Upload Bulk Payment`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          // initialValues={singlePaymentObj}
        >
          <Form.Item
            name="pyWalId"
            className=""
            label={<span>Payment Source</span>}
            rules={[
              {
                required: true,
                message: "Please select payment source",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                subwalletData?.length > 0 &&
                subwalletData?.map((item) => ({
                  value: item?.walId,
                  label:
                    item?.walName +
                    " - " +
                    item?.walCode +
                    " - " +
                    item?.walCurrency +
                    " " +
                    item?.walAvailableBalance,
                }))
              }
              notFoundContent={
                <div
                  onClick={() => navigate("/my-wallet")}
                  className="cursor-pointer text-ndovuRed"
                >
                  Assign wallet to this user
                </div>
              }
              onChange={(value) => {
                const selectedItem = subwalletData?.find(
                  (item) => item?.walId === value
                );
                setPaymentSourceName(selectedItem?.walName || "");
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchSubWalletData();
              }}
              dropdownRender={(menu) => (
                <>
                  {dropLoading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>
          <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
            <Form.Item
              name="pyPcId"
              className=""
              label={<span>Category</span>}
              rules={[
                {
                  required: false,
                  message: "Please select payment category",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dataCat?.length > 0 &&
                  dataCat?.map((item) => ({
                    value: item?.pcId,
                    label: item?.pcName,
                  }))
                }
                onChange={(value) => {
                  fetchSubCategoryData(value);
                  form.resetFields(["pyPscId"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ padding: 8 }}>
                      <Button
                        type="link"
                        onClick={() => setopenCategory(true)}
                        style={{ padding: 0 }}
                      >
                        + Add new Category
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>
            {pyPcId && (
              <Form.Item
                name="pyPscId"
                className=""
                label={<span>Sub Category</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment sub-category",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataSubCat?.length > 0 &&
                    dataSubCat?.map((item) => ({
                      value: item?.pscId,
                      label: item?.pscName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ padding: 8 }}>
                        <Button
                          type="link"
                          onClick={() => setopenSubCategory(true)}
                          style={{ padding: 0 }}
                        >
                          + Add new Sub-Category
                        </Button>
                      </div>
                    </>
                  )}
                />
              </Form.Item>
            )}
          </div>
          <Form.Item
            name="pdTransType"
            className=""
            label={<span>Payment Method</span>}
            rules={[
              {
                required: true,
                message: "Please select payment method",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                paymentMethodsData?.length > 0 &&
                paymentMethodsData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                setShow(value);
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
          {show === "BANK" && (
            <>
              {glbLoading ? (
                <Spin className="sms-spin" />
              ) : (
                <div
                  className=" flex items-end cursor-pointer"
                  onClick={() => handleDownload("BANK")}
                >
                  <Tooltip title="Download file ">
                    <img src={svg59} alt="svg59" />
                  </Tooltip>
                  <span className="ml-3 text-[15px] font-bold font-dmSans text-blu underline">
                    Click to download bank template
                  </span>
                </div>
              )}
            </>
          )}

          {show === "MOBILE_MONEY" && (
            <>
              {glbLoading ? (
                <Spin className="sms-spin" />
              ) : (
                <div
                  className=" flex items-end cursor-pointer"
                  onClick={() => handleDownload("MPESA")}
                >
                  <Tooltip title="Download file ">
                    <img src={svg59} alt="svg59" />
                  </Tooltip>
                  <span className="ml-3 text-[15px] font-bold font-dmSans text-blu underline">
                    Click to download mpesa template
                  </span>
                </div>
              )}
            </>
          )}

          <div className="dropzone-wrapper mt-5 mb-5">
            <div className="dropzone-desc">
              <img className="" src={svg60} alt="svg60" />
              <p className="ant-upload-text text-[#7E93AE] text-[14px] font-[400]">
                Drag & Drop or{" "}
                <span className="text-[#010101] font-[500]">Choose file</span>{" "}
                to upload
              </p>
              <p className="ant-upload-hint text-[#010101] font-[500]">.xlsx</p>
            </div>
            <input
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              type="file"
              name="file"
              className="dropzone"
            />
          </div>

          {file?.name && !uploadedFile && (
            <div className="flex items-center justify-between my-2">
              <p className="text-[16px] f0nt-[600] text-[#010101] w-[80%] truncate">
                {file?.name}
              </p>
              <img
                src={deleteRed}
                alt="deleteRed"
                onClick={() => setFile(null)}
                className="text-[red] text-[25px] cursor-pointer"
              />
            </div>
          )}

          {uploadedFile && (
            <div
              className="flex flex-col text-ndovuRed items-start"
              onClick={() => handleDownloadUploaded(uploadedFile)}
            >
              The uploaded file contains errors. Please download it, make the
              necessary corrections, and reupload it{" "}
              <span className=" underline cursor-pointer">
                {" "}
                {formatPath(uploadedFile)}
              </span>
            </div>
          )}

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Upload"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <CategoryAdd
        isModalOpen={openCategory}
        handleCancel={handleCancelCategory}
        handleFetch={fetchCategoryData}
        prodd=""
      />
      <SubCategoryAdd
        isModalOpen={openSubCategory}
        handleCancel={handleCancelSubCategory}
        handleFetch={() => fetchSubCategoryData(form.getFieldValue("pyPcId"))}
        prodd=""
      />
    </>
  );
};
export default BulkPaymentModal;
